import { Select as AntdSelect } from "antd";
import styled from "styled-components";
import { primitives } from "../../designsystem/primitives";
import "./Select.scss";
import { ForwardedRef, forwardRef } from "react";
import { RefSelectProps } from "antd/lib/select";

export const StyledSelect = styled(AntdSelect)`
  &:hover {
    border-color: ${primitives.colors.blue[500]};
  }

  &.ant-input-status-error {
    border-color: ${primitives.colors.red[700]};

    &:hover {
      border-color: ${primitives.colors.red[700]};
    }
  }

  &.ant-input-status-warning {
    border-color: ${primitives.colors.yellow[700]};

    &:hover {
      border-color: ${primitives.colors.yellow[700]};
    }
  }

  &:focus:not(#priority) {
    box-shadow: none;
  }

  .ant-select-selector:not(#priority) {
    border-color: ${primitives.colors.grey[300]};
    padding: 4px 14px;
    border-radius: 4px;
    height: auto;
    box-shadow: 0px 4px 4px 0px rgba(134, 134, 134, 0.2);
    &:hover {
      border-color: ${primitives.colors.blue[500]};
    }
    &:focus-within {
      border-color: ${primitives.colors.blue[500]};
    }
  }
`;

export const Select = forwardRef(
  (props: Parameters<typeof AntdSelect>[0], ref: ForwardedRef<RefSelectProps>) => {
    return <StyledSelect {...props} dropdownClassName="ds-select-dropdown" ref={ref} />;
  }
);
